export enum ShipmentDirection {
  All = 'All',
  Outbound = 'OUTBOUND',
  Inbound = 'INBOUND',
}
